import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    SGA_GET_ZONAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.get.zonas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_ZONAS_ASIENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.zonas.asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_CREATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.create'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_GUARDAR_DATOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.guardar-datos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_GUARDAR_CONDICIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.guardar-condiciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_ELIMINAR_DATOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.eliminar-datos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_GET_DESCUENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.get.descuentos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_ENTITLEMENTS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.entitlements'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_SOLICITAR_COBRO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.solicitar-cobro'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_SOLICITAR_DOCUMENTACION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.solicitar-documentacion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_RESUMEN : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.resumen'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_MEMBRESIA_INFO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.membresia.info'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_MEMBRESIA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.membresia'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_BUSCAR_ABONO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.buscar.abono'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_ABONO_BIND : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.abono.bind'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    SGA_PROFILE_EVENTOS_CESION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.eventos-cesion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_PROFILE_ABONO_ENTRADAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.abono.entradas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_EVENTO_CEDER : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.evento.ceder'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_EVENTO_RECUPERAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.evento.recuperar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_DESCUENTOS_CODIGO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.descuentos-codigo'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_DESCUENTOS_CODIGO_GUARDAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.descuentos-codigo.guardar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },    
    SGA_PROFILE_ABONO_CESION_BENEFITS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.abono.cesion.benefits'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_PROFILE_ABONOS_RENEWAL_INFO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.abonos.renewal-info'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_PROFILE_ABONOS_RENEWAL_DISCOUNTS_VERIFY : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.abonos.renewal-discounts.verify'), {
                abonado_id: data.abonado_id,
                filters: { codigo: data.codigo }
            }).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_PROFILE_MEMBRESIAS_RENEWAL_INFO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.membresias.renewal-info'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_PROFILE_ABONOS_RENOVACION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.abonos.renovacion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_PROFILE_MEMBRESIAS_RENOVACION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.membresias.renovacion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_PROFILE_ABONO_CAMBIO_ASIENTO_PRECIOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            var params = { abonado_id: data.abonado_id };
            if (data.seat_id) {
                params.filters = { seat_id: data.seat_id };
            }
            api.call(config.getAPIRoute('sga.profile.abono.cambio-asiento.precios'), params).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_PROFILE_ABONO_CAMBIO_ASIENTO_CARRITO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.abono.cambio-asiento.carrito'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
}

export default {
    actions
};